<template>
  <div ref="menuRootRef" class="relative">
    <button
      type="button"
      class="flex min-h-[44px] max-w-[10rem] items-center gap-1 py-3 pl-4 pr-3 text-lg hover:text-accent-text"
      :aria-expanded="isOpen"
      aria-haspopup="menu"
      @click.stop="toggleMenu"
    >
      <!-- Future avatar slot -->
      <span class="truncate">{{ label }}</span>
      <i
        class="fa-solid fa-chevron-down shrink-0 text-xs text-text-muted"
        aria-hidden="true"
      ></i>
    </button>

    <div
      v-if="isOpen"
      role="menu"
      class="absolute right-0 z-50 mt-1 min-w-[10rem] rounded border border-border-subtle bg-surface-1 py-1 text-base shadow-lg"
    >
      <RouterLink
        to="/profile"
        role="menuitem"
        class="block px-4 py-2 min-h-[44px] flex items-center hover:bg-surface-hover"
        @click="closeMenu"
      >
        Profile
      </RouterLink>
      <RouterLink
        to="/account"
        role="menuitem"
        class="block px-4 py-2 min-h-[44px] flex items-center hover:bg-surface-hover"
        @click="closeMenu"
      >
        Account
      </RouterLink>
      <RouterLink
        v-if="authState.isAdmin"
        to="/admin/users"
        role="menuitem"
        class="block px-4 py-2 min-h-[44px] flex items-center hover:bg-surface-hover"
        @click="closeMenu"
      >
        Admin
      </RouterLink>
      <button
        type="button"
        role="menuitem"
        class="block w-full px-4 py-2 min-h-[44px] text-left hover:bg-surface-hover"
        @click="onLogoutClick"
      >
        Logout
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { RouterLink } from 'vue-router';
import { authState } from '@/utils/auth';

defineProps({
  label: {
    type: String,
    default: 'Account',
  },
});

const emit = defineEmits(['logout']);

const isOpen = ref(false);
const menuRootRef = ref(null);

function toggleMenu() {
  isOpen.value = !isOpen.value;
}

function closeMenu() {
  isOpen.value = false;
}

function onLogoutClick() {
  closeMenu();
  emit('logout');
}

function onDocumentKeydown(event) {
  if (event.key === 'Escape') {
    closeMenu();
  }
}

function onDocumentClick(event) {
  if (!isOpen.value) {
    return;
  }
  const target = event.target;
  if (!(target instanceof Node)) {
    return;
  }
  if (menuRootRef.value?.contains(target)) {
    return;
  }
  closeMenu();
}

onMounted(() => {
  document.addEventListener('click', onDocumentClick);
  document.addEventListener('keydown', onDocumentKeydown);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', onDocumentClick);
  document.removeEventListener('keydown', onDocumentKeydown);
});
</script>
